/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-tablo-bord-recherche': {
    width: 79.751,
    height: 80,
    viewBox: '-0.05 136 79.751 80',
    data: '<path pid="0" d="M53.9 184.5c-12.5 0-22.601-10.2-22.601-22.6 0-12.5 10.2-22.601 22.601-22.601 12.5 0 22.6 10.2 22.6 22.601.1 12.4-10.1 22.6-22.6 22.6M9 211.9c-1.3 1.3-3.5 1.3-4.9 0-1.3-1.301-1.3-3.5 0-4.9L26 185.1l4.9 4.9L9 211.9zM53.9 136c-14.2 0-25.8 11.6-25.8 25.8 0 6.601 2.5 12.601 6.6 17.2l-5.1 5.1-2.4-2.399c-.6-.601-1.6-.601-2.3 0l-23 23c-2.6 2.6-2.6 6.8 0 9.399 1.3 1.301 3 1.9 4.7 1.9 1.7 0 3.4-.6 4.7-1.9l23-23c.6-.6.6-1.6 0-2.3l-2.5-2.5 5.1-5.1c4.5 4 10.5 6.399 17 6.399 14.199 0 25.8-11.6 25.8-25.8C79.8 147.6 68.2 136 53.9 136"/>'
  }
})
